const partners = [
  {
    name: "Kaduna State Government through the Ministry of Agriculture and Planning and Budget Commission.",
    logo: "https://i.postimg.cc/yx64z4PV/IMG-20250703-WA0009.jpg",
    
  },
  {
    name: "Kaduna State Agricultural Development Agency (KADA)",
    logo: "https://i.postimg.cc/yx64z4PV/IMG-20250703-WA0009.jpg",
  },
  
  {
    name: "Federal Ministry of Livestock Development.",
    logo: "https://i.postimg.cc/LXXwyB6X/Screenshot-4-7-2025-134647-www-bing-com.jpg",
  },
  {
    name: "Federal Ministry of Agriculture and Food Security",
    logo: "https://i.postimg.cc/LXXwyB6X/Screenshot-4-7-2025-134647-www-bing-com.jpg",
    
  },
  {
    name: "Federal Ministry of Budget and National Planning",
    logo: "https://i.postimg.cc/LXXwyB6X/Screenshot-4-7-2025-134647-www-bing-com.jpg",
    
  },
  
  {
    name: "Federal Ministry of Water Resources",
    logo: "https://i.postimg.cc/LXXwyB6X/Screenshot-4-7-2025-134647-www-bing-com.jpg",
    
  },{
    name: "Federal Ministry of Information and National Orientation",
    logo: "https://i.postimg.cc/LXXwyB6X/Screenshot-4-7-2025-134647-www-bing-com.jpg",
    
  },
  {
    name: "Bank of Agriculture (BoA)",
    logo: "https://i.postimg.cc/3JR5ShN1/IMG-20250703-WA0013.jpg",
    
  },{
    name: "Bank of Industry (BoI)",
    logo: "https://i.postimg.cc/gj4K11Sb/Screenshot-4-7-2025-13530-www-bing-com.jpg",
    
  },{
    name: "Development Bank of Nigeria (DBN)",
    logo: "https://i.postimg.cc/BZNfBbSt/IMG-20250703-WA0012.jpg",
    
  },{
    name: "Nigerian Incentive Risk-Sharing on Agricultural Lending Plc (Nirsal Plc) ",
    logo: "https://i.postimg.cc/MHsk6PP1/IMG-20250703-WA0010.jpg",
    
  },{
    name: "National Agency for Science and Engineering Infrastructure (NASENI)",
    logo: "https://i.postimg.cc/3JcMzqDT/IMG-20250703-WA0014.jpg",
    
  },{
    name: "Rural Electrification Agency (REA)",
    logo: "https://i.postimg.cc/yxFNdHq2/Screenshot-4-7-2025-135940-www-bing-com.jpg",
    
  },{
    name: "Small and Medium Enterprise Development Agency (SMEDAN)",
    logo: "https://i.postimg.cc/QdKLDqpW/IMG-20250703-WA0015-1.jpg",
    
  },{
    name: "Nigerian Electricity Regulatory Commission (NERC)",
    logo: "https://i.postimg.cc/hG5vZsbZ/Screenshot-4-7-2025-14017-www-bing-com.jpg",
    
  },{
    name: "Infrastucture Concession Regulatory Commission (ICRC)",
    logo: "https://i.postimg.cc/rmfJPvYX/Screenshot-4-7-2025-141459-www-bing-com.jpg",
    
  },{
    name: "Bureau of Public Enterprises (BPE)",
    logo: "https://i.postimg.cc/nhTCBpsJ/Screenshot-4-7-2025-14127-www-bing-com.jpg",
    
  },{
    name: "Federal Cooperative Colleges",
    logo: "https://i.postimg.cc/02Y65pPr/Screenshot-4-7-2025-14230-www-bing-com.jpg",
    
  },
  {
    name: "Prime Anchors (Integrated Farms, processors, off-Takers)",
    logo: "/partners/staragri.png",
    
  },
  {
    name: "Electric Distribution Companies (DISCOS) and Renewable Energy Partners ",
    logo: "/partners/staragri.png",
    
  },
  {
    name: "Prime Agro and Energy Facilitation Services Ltd",
    logo: "/partners/staragri.png",
    
  },
  {
    name: "Right and Democracy Volunteers (RDV)",
    logo: "/partners/staragri.png",
    
  },
];
export default partners;






